//YODA
import controlLargeHeadingFactory         from '../../factories/ControlLargeHeadingFactory';
import controlMediumHeadingFactory        from '../../factories/ControlMediumHeadingFactory';
import controlSmallHeadingFactory         from '../../factories/ControlSmallHeadingFactory';
import controlSmallTextFactory            from '../../factories/ControlSmallTextFactory';
import controlTextFactory                 from '../../factories/ControlTextFactory';
import controlButtonFactory               from '../../factories/ControlButtonFactory';
import controlSubmitButtonFactory         from '../../factories/ControlSubmitButtonFactory';
import controlTableFactory                from '../../factories/ControlTableFactory';
import controlPictureFactory              from '../../factories/ControlPictureFactory';
import controlPageButtonFactory           from '../../factories/ControlPageButtonFactory';
import controlInputTextFactory            from '../../factories/ControlInputTextFactory';
import controlDropDownFactory             from '../../factories/ControlDropDownFactory';
import controlTextAreaInputFactory        from '../../factories/ControlTextAreaInputFactory';
import controlCaptchaFactory              from '../../factories/ControlCaptchaFactory';
import controlInputNumericFactory         from '../../factories/ControlInputNumericFactory';
import controlBulletTextFactory           from '../../factories/ControlBulletTextFactory';
import controlInputDateFactory            from '../../factories/ControlInputDateFactory';
import controlInputTimeFactory            from '../../factories/ControlInputTimeFactory';
import controlRadioButtonFactory          from '../../factories/ControlRadioButtonFactory';
import controlCheckboxFactory             from '../../factories/ControlCheckboxFactory';
import controlMaskedTextFactory           from '../../factories/ControlMaskedTextFactory';
import controlPasswordInputFactory        from '../../factories/ControlPasswordInputFactory';
import controlProgressBarFactory          from '../../factories/ControlProgressBarFactory';
import controlNumericStepperFactory       from '../../factories/ControlNumericStepperFactory';
import controlFileAttachmentFactory       from '../../factories/ControlFileAttachmentFactory';
import controlListFactory                 from '../../factories/ControlListFactory';
import controlRadioButtonGroupFactory     from '../../factories/ControlRadioButtonGroupFactory';
import controlCheckboxGroupFactory        from '../../factories/ControlCheckboxGroupFactory'
import controlPrintButtonFactory          from '../../factories/ControlPrintButtonFactory';
import controlPlayReportButtonFactory     from '../../factories/ControlPlayReportButtonFactory';
import controlPlayFormButtonFactory       from '../../factories/ControlPlayFormButtonFactory';
import controlLinkFactory                 from '../../factories/ControlLinkFactory';
import controlRankingFactory              from '../../factories/ControlRankingFactory'
import controlHorizontalSliderFactory     from '../../factories/ControlHorizontalSliderFactory';
import controlWebSignatureFactory         from '../../factories/ControlWebSignatureFactory';
import controlSectionFactory from '../../factories/mobile/ControlSectionFactory'
import controlHorizontalSeparatorFactory from "../../factories/ControlHorizontalSeparatorFactory";
import controlGroupFactory from "../../factories/ControlGroupFactory";

class MobileFactoryService {

      get factories() {
        return {
            // Sections
            'control_section':             {factory: controlSectionFactory, name: 'Section' },
            // Controls:
            //Inputs
            'control_text_input':          {factory: controlInputTextFactory, name: 'Text Input'},
            'control_multiple_text_input': {factory: controlTextAreaInputFactory, name: 'Multiline Text Input'},
            'control_numeric_input':       {factory: controlInputNumericFactory, name: 'Numeric Input'},
            'control_date_input':          {factory: controlInputDateFactory, name: 'Date Input'},
            'control_time_input':          {factory: controlInputTimeFactory, name: 'Time Input'},
            'control_checkbox':            {factory: controlCheckboxFactory, name: 'Checkbox'},
            'control_radio_button':        {factory: controlRadioButtonFactory, name: 'Radio Button'},
            'control_drop_down':           {factory: controlDropDownFactory, name: 'Drop-Down', icon: 'pf-dropdown' },
            'control_mask_text_input':     {factory: controlMaskedTextFactory, name: 'Mask Text Input'},
            'control_numeric_stepper':     {factory: controlNumericStepperFactory, name: 'Numeric Stepper'},
            'control_password_input':      {factory: controlPasswordInputFactory, name: 'Password Input'},
            'control_websignature':        {factory: controlWebSignatureFactory, name : 'Web Signature'},
            'control_horizontal_slider':   {factory:controlHorizontalSliderFactory, name:'Horizontal Slider', icon: 'pf-horizontal-slider'},
            'control_ranking':             {factory: controlRankingFactory, name: 'Ranking', icon: 'pf-ranking'},

            //Groups
            'control_checkbox_group':      {factory: controlCheckboxGroupFactory, name: 'Checkbox Group'},
            'control_radio_button_group':  {factory: controlRadioButtonGroupFactory, name: 'Radio Button Group'},

            'control_group':               {factory: controlGroupFactory, name: 'Group'},

            //Buttons
            'control_button':              {factory: controlButtonFactory, name: 'Button'},
            'control_page_button':         {factory: controlPageButtonFactory, name: 'Page Button'},
            'control_print_button':        {factory: controlPrintButtonFactory, name: 'Print Button'},
            'control_submit_button':       {factory: controlSubmitButtonFactory, name: 'Submit Button'},
            'control_play_form_button':    {factory: controlPlayFormButtonFactory, name: 'Show App Button'},
            'control_play_report_button':  {factory: controlPlayReportButtonFactory, name: 'Show Report Button'},

            //Text
            'control_text':                {factory: controlTextFactory, name: 'Text' },
            'control_small_text':          {factory: controlSmallTextFactory, name: 'Small Text'},
            'control_bullet_text':         {factory : controlBulletTextFactory, name : 'Bullet Text'},
            'control_large_heading':       {factory: controlLargeHeadingFactory, name: 'Large Heading'},
            'control_medium_heading':      {factory: controlMediumHeadingFactory, name: 'Medium Heading'},
            'control_small_heading':       {factory: controlSmallHeadingFactory, name: 'Small Heading'},
            'control_link':                {factory: controlLinkFactory, name:'Link'},
            'control_horizontal_separator':{factory: controlHorizontalSeparatorFactory, name: 'Horizontal Separator'},

            //Containers
            'control_list':                {factory: controlListFactory, name: 'List'},
            'control_progress_bar':        {factory: controlProgressBarFactory, name: 'Progress Bar' },
            'control_captcha':             {factory: controlCaptchaFactory, name: 'Captcha'},
            'control_file_attachment':     {factory: controlFileAttachmentFactory, name: 'File Attachment'},

            //Picture
            'control_picture':             {factory: controlPictureFactory, name: 'Picture'},

            //Table
            'control_table':               {factory: controlTableFactory, name: 'Table'}
      };
    }

}

const mobileFactoryService = new MobileFactoryService();
export default mobileFactoryService;